import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select as MUISelect,
} from '@mui/material';
import size from 'lodash/size';

import { Options, Props } from './props';

const SelectView: React.FC<Props> = (props) => {
  const {
    options,
    value,
    onChange,
    label,
    preMenuItem,
    postMenuItem,
    name,
    emptyView,
    inputLabelProps,
    selectProps,
    ...rest
  } = props;
  const renderOptions = () => {
    if (size(options) === 0)
      return (
        emptyView ?? (
          <Box
            sx={{
              padding: 3,
            }}
          >
            No options
          </Box>
        )
      );
    return options.map((val, index) => (
      // the any type is for this purpose https://github.com/mui/material-ui/issues/14286
      // as I can't pass object down
      <MenuItem key={index} value={val?.value as any}>
        {val?.label}
      </MenuItem>
    ));
  };
  return (
    <FormControl fullWidth {...rest} size="small">
      <InputLabel {...inputLabelProps}>{label}</InputLabel>
      <MUISelect
        name={name}
        value={value}
        label={label}
        onChange={onChange}
        {...selectProps}
      >
        {preMenuItem && (
          <MenuItem
            onClickCapture={(e) => {
              e.stopPropagation();
              preMenuItem?.onClick?.(e);
            }}
            {...preMenuItem.props}
            value=""
          >
            {preMenuItem.render(options)}
          </MenuItem>
        )}
        {renderOptions()}
        {postMenuItem && (
          <MenuItem
            onClickCapture={(e) => {
              e.stopPropagation();
              postMenuItem?.onClick?.(e);
            }}
            {...postMenuItem?.props}
            value=""
          >
            {postMenuItem?.render(options)}
          </MenuItem>
        )}
      </MUISelect>
    </FormControl>
  );
};

export type SelectProps = Props;
export type SelectOptionsProps = Options[];
export const Select = SelectView;
export default SelectView;
